export const ClinicTypeEnum = {
    INTEGRATED: 'Integrated',
    NOT_INTEGRATED: 'Not Integrated',
}
